"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncService = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const store_1 = require("@completeanatomy/store");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
require("reflect-metadata");
const typedi_1 = require("typedi");
let SyncService = class SyncService {
    constructor(bridge, store) {
        this.bridge = bridge;
        this.store = store;
        /**
         * Handler for bridgeObjectAdded event
         *
         * @param notification — Bridge notification with added object
         */
        this.bridgeObjectAdded = (notification) => {
            const reducer = this.createReducer(notification);
            if (notification.identifier in this.store.reducers) {
                return;
            }
            this.store.injectReducers({
                [notification.identifier]: reducer,
            });
            this.store.dispatch(this.createAction(notification, bridge_schema_1.bridgeObjectAdded));
        };
        /**
         * Handler for bridgeObjectRemoved event
         *
         * @param notification — notification with removed object identifier
         */
        this.bridgeObjectRemoved = (notification) => {
            this.store.dispatch(this.createAction(notification, bridge_schema_1.bridgeObjectRemoved));
            this.store.removeReducer(notification.identifier);
        };
        /**
         * Handler for bridgeObjectChanged event
         *
         * @param notification — notification with object identifier and changes
         */
        this.bridgeObjectChanged = (notification) => {
            /**
             * If bridge object doesn't exist, create it
             */
            if (!this.store.reducers[notification.identifier]) {
                this.bridgeObjectAdded({
                    identifier: notification.identifier,
                    object: {},
                });
            }
            try {
                this.store.dispatch(this.createAction(notification, bridge_schema_1.bridgeObjectChanged));
            }
            catch (e) {
                console.error(e);
            }
        };
        this.bridge = bridge;
        this.store = store;
        this.bridge.on(bridge_schema_1.bridgeObjectAdded, this.bridgeObjectAdded);
        this.bridge.on(bridge_schema_1.bridgeObjectRemoved, this.bridgeObjectRemoved);
        this.bridge.on(bridge_schema_1.bridgeObjectChanged, this.bridgeObjectChanged);
    }
    /**
     * Creates new reducer for the object
     *
     * @param notification — bridgeObjectAdded notification with initial object state
     * @private
     */
    createReducer(notification) {
        const changedActionType = `${notification.identifier}/${bridge_schema_1.bridgeObjectChanged}`;
        const addedActionType = `${notification.identifier}/${bridge_schema_1.bridgeObjectAdded}`;
        const removedActionType = `${notification.identifier}/${bridge_schema_1.bridgeObjectRemoved}`;
        const object = notification.object;
        return (state = object || {}, action) => {
            var _a;
            switch (action.type) {
                case changedActionType:
                    const newState = Object.assign({}, state);
                    const { payload } = action;
                    const { changes } = payload;
                    if (payload.keyPath === '') {
                        return typeof changes === 'object' &&
                            !Array.isArray(changes) &&
                            changes !== null
                            ? Object.assign(Object.assign({}, newState), (0, cloneDeep_1.default)(changes)) : (0, cloneDeep_1.default)(changes);
                    }
                    const keys = (_a = payload === null || payload === void 0 ? void 0 : payload.keyPath) === null || _a === void 0 ? void 0 : _a.split('.');
                    /**
                     * We need to update all object links from changed keypath up to the root
                     */
                    keys.reduce((subState, key, index) => {
                        if (!subState) {
                            return subState;
                        }
                        if (index === keys.length - 1) {
                            /**
                             * If changes is object, merge it with existing one, otherwise just set the value
                             */
                            if (typeof changes === 'object' &&
                                !Array.isArray(changes) &&
                                changes !== null) {
                                subState[key] = Object.assign(Object.assign({}, subState[key]), changes);
                                return;
                            }
                            subState[key] = payload.changes;
                            return;
                        }
                        const obj = Array.isArray(subState[key])
                            ? [...subState[key]]
                            : Object.assign({}, subState[key]);
                        subState[key] = obj;
                        return obj;
                    }, newState);
                    return newState;
                case addedActionType:
                    return (0, cloneDeep_1.default)(object);
                case removedActionType:
                    return null;
                default:
                    return state;
            }
        };
    }
    /**
     * Creates action to change object state
     *
     * @param notification — Bridge notification with object identifier and changes
     * @param type — type of action: object added, object changed or object removed
     * @private
     */
    createAction(notification, type) {
        return {
            type: `${notification.identifier}/${type}`,
            payload: notification,
        };
    }
};
exports.SyncService = SyncService;
exports.SyncService = SyncService = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [bridge_schema_1.BridgeInterface, Object])
], SyncService);
